import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../MainStyle.css";
import {
  WEBSITE_NAME,
  API_SIGNIN_ACCOUNT,
} from "../modals/Constants";
import { setStorage, getStorage } from "../modals/Storage";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import HeaderView from "../other-components/HeaderView/view";
import { useGoogleLogin } from "@react-oauth/google";
import Button from "../UI/Button/ui";
import AlertDialog from "../dialogs/AlertDialog/dialog";

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [tempGoogleAuthData, setTempGoogleAuthData] = useState(null);

  const signInWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => setTempGoogleAuthData(codeResponse),
    onError: (error) => console.log("Login Failed:", error),
  });

  const [inMobileNum, setInMobileNum] = useState("");
  const [inPassword, setInPassword] = useState("");
  const [formStep, setFormStep] = useState(1);

  const [alertDialog, updatetAlertDialog] = useState({
    title: 'Required!',
    description: '',
    visible: false
  });

  const [pageConst, setConstants] = useState({
    pageTitle: "Login",
    inMobileNum: "",
    inPassword: "",
    isSessionExist: true,
  });

  function setAlertDialog({ title = '', description = '', visible = true }) {
    if (title === '') {
      title = alertDialog.title;
    }

    updatetAlertDialog((previousState) => {
      return {
        ...previousState,
        title: title,
        description: description,
        visible: visible
      };
    });
  }

  const validateSigninWithMobile = () => {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const response = await res.json();
        const account = response.data;
        setLoading(false);

        if (response.status_code == "account_logedin") {
          setFormStep(2)
        } else if (response.status_code == "account_progress") {
          navigate("/onboard?id=" + account.account_id + "&auth=" + account.account_secret + "&mode=1", { replace: true });
        } else if (response.status_code == "otp_required") {
          navigate("/onboard?id=" + account.account_id + "&auth=" + account.account_secret + "&mode=2", { replace: true });
        } else if (response.status_code == "password_incorrect") {
          setAlertDialog({ title: "Password Incorrect!", description: "You've entered wrong password. Please try again!" });
        } else if (response.status_code == "success") {
          setStorage("accountID", account.account_id);
          setStorage("accountSecret", account.account_secret);
          navigate("/", { replace: true });
        }
      } catch (error) {
        setLoading(false);
        setAlertDialog({ title: "Error", description: "There was a technical issue! Please try again!" });
      }
    }

    if (inMobileNum.length == 10) {
      const formData = {
        SIGNIN_MOBILE: inMobileNum,
        SIGNIN_PASSWORD: inPassword,
      };

      if (formStep === 2 && inPassword === "") {
        setAlertDialog({ title: "Password required!", description: "Please enter the password to continue." });
        return;
      }

      setLoading(true);
      requestAPI(API_SIGNIN_ACCOUNT, formData);
    }
  };

  const validateSigninWithEmail = (data) => {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const response = await res.json();
        const account = response.data;
        setLoading(false);

        if (response.status_code == "account_logedin") {
          setStorage("accountID", account.account_id);
          setStorage("accountSecret", account.account_secret);
          navigate("/", { replace: true });
        } else if (response.status_code == "account_progress") {
          navigate("/onboard?id=" + account.account_id + "&auth=" + account.account_secret + "&mode=1", { replace: true });
        } else if (response.status_code == "otp_required") {
          navigate("/onboard?id=" + account.account_id + "&auth=" + account.account_secret + "&mode=2", { replace: true });
        } else if (response.status_code == "password_incorrect") {
          setAlertDialog({ title: "Password Incorrect!", description: "You've entered wrong password. Please try again!" });
        }
      } catch (error) {
        setLoading(false);
        setAlertDialog({ title: "Error", description: "There was a technical issue! Please try again!" });
      }
    }

    if (data) {
      let tempFullname = data.given_name + " " + data.family_name;
      const formData = {
        SIGNIN_EMAIL: data.email,
        SIGNIN_MOBILE: "",
        SIGNIN_FULLNAME: tempFullname,
      };
      requestAPI(API_SIGNIN_ACCOUNT, formData);
    }
  };

  const getEmailInfo = () => {
    async function requestAPI(url) {
      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tempGoogleAuthData.access_token}`,
            Accept: "application/json",
          },
        });

        setTempGoogleAuthData(null);

        const data = await res.json();

        validateSigninWithEmail(data);
      } catch (error) {
        setLoading(false);
      }
    }

    setLoading(true);
    requestAPI(
      `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tempGoogleAuthData.access_token}`
    );
  };

  useEffect(() => {
    if (getStorage("accountID") != "" && getStorage("accountSecret") != "") {
      navigate("/", { replace: true });
    } else {
      if (tempGoogleAuthData != null) {
        getEmailInfo();
      }
    }
  }, [tempGoogleAuthData]);

  return (
    <div className={[general.appView]}>
      <AlertDialog
        isOpen={alertDialog.visible}
        title={alertDialog.title}
        description={alertDialog.description}
        onClose={() => setAlertDialog({ visible: false })}
        actions={[
          { label: "Close", variant: "neutral", onClick: () => setAlertDialog({ visible: false }) }
        ]}
      />

      <LoadingDialog
        isOpen={loading}
      />

      <div className={[general.appChildView, general.hideScrollBar].join(" ")}>
        <HeaderView categories={pageConst.categoryList} screen={"login"} />

        <div className={screen.signinView}>
          <div className={screen.aboutView}>
            {/* <h2 className="ft-sz-23">
              Welcome to the world of {WEBSITE_NAME}
            </h2> */}
            <img
              className="w-80 mg-t-20"
              src={require("../media/illustrations/1.webp")}
            />
          </div>

          <div className={screen.contentsView}>
            <div className={screen.contents}>
              <h1 className="ft-sz-20">Log In /Sign Up</h1>
              <p className="ft-sz-14 mg-t-10">
                for Latest trends, exciting offers and everything{" "}
                {WEBSITE_NAME}
              </p>

              <div className={[general.inpBoxOutline, general.mgT30px].join(" ")}>
                <p className={general.hintView}>+91</p>
                <input
                  type="number"
                  placeholder="Enter Mobile Number"
                  autoComplete="off"
                  onChange={(e) => setInMobileNum(e.target.value)}
                ></input>
              </div>

              {formStep === 2 && (
                <div className={general.mgT15px}>
                  <div className={general.inpBoxOutline}>
                    <input type="password" placeholder="Enter Password" autoComplete="new-password" onChange={e => setInPassword(e.target.value)}></input>
                  </div>
                </div>
              )}

              <br></br>
              <Button
                text={formStep === 1 ? "Continue" : "Signin"}
                rounded={true}
                fullWidth={true}
                action={{ onClick: () => validateSigninWithMobile() }} />

              {formStep === 1 && (
                <>
                  <p className="w-100 txt-a-center ft-wgt-600 mg-t-20 bg-white">
                    OR
                  </p>

                  <div
                    className={`w-100 h-50-p v-center ft-sz-16 br-10 br-a-grey mg-t-20`}
                    onClick={() => signInWithGoogle()}
                  >
                    <div
                      className={`h-20-p w-20-p lodr-v ${pageConst.isLoadingShow == false ? "hide-v" : ""
                        }`}
                    ></div>

                    <div
                      className={`v-center ${pageConst.isLoadingShow == true ? "hide-v" : ""
                        }`}
                    >
                      <img
                        className="h-w-22"
                        src={require("../media/icons/google_icon.png")}
                      />
                      <span className="ft-wgt-600 mg-l-10">
                        Continue with Google
                      </span>
                    </div>
                  </div>
                </>
              )}

              <div className="pd-10 txt-a-center ft-sz-13 mg-t-20 mg-b-30">
                By creating an account or logging in, you agree with{" "}
                {WEBSITE_NAME}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Login;
